import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../localization/language';
import Password from './Password';
import Mobile from './Mobile';
import Email from './Email';
import Realinfo from './Realinfo';

class ActionPanel extends React.Component {
	render () {
		return (
			<div className="msidebar-panel">
				<Password />
				<Mobile />
				<Email />
				<Realinfo />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

export default connect(mapStateToProps)(ActionPanel);


// WEBPACK FOOTER //
// ./app/components/mobile/ActionPanel.js